import config from '../config';

export default function serverImageUrl(options: {
  id: string;
  w?: number;
}): string {
  const { id, w } = options;
  return `${config.SERVER_ROOT}/media/transformed/${id}${w ? `?w=${w}` : ''}`;
}
